import React, { useEffect, useRef, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import api from '../../utils/api';
import '../../styles/crm.css';
import '../../styles/crmOutreach.css';
export default function ProjectOutreachSummary({ projectId, onCount }) {
    const [params] = useSearchParams(), [data, setData] = useState(null), [error, setError] = useState('');
    const workspace = params.get('outreachWorkspace') === 'test' ? 'test' : 'live';
    const count = useRef(onCount); useEffect(() => { count.current = onCount; }, [onCount]);
    useEffect(() => {
        const controller = new AbortController(); setData(null); setError('');
        api.get(`/crm-outreach/projects/${projectId}/summary`, { params: { workspace }, signal: controller.signal })
            .then(({ data }) => { if (!controller.signal.aborted) { setData(data); count.current?.(data.vendors); } })
            .catch(problem => { if (!controller.signal.aborted) setError(problem.response?.data?.message || 'Could not load vendor outreach.'); });
        return () => controller.abort();
    }, [projectId, workspace]);
    const target = new URLSearchParams({ workspace, project: projectId, view: params.get('reviewVendor') ? 'coordination' : 'project' });
    for (const key of ['reviewVendor', 'reviewDraft', 'reviewEmails']) if (params.get(key)) target.set(key, params.get(key));
    return <section className="crm-ui crm-panel outreach-project-summary">
        <div><span className="crm-eyebrow">CRM OUTREACH</span><h2>Vendor outreach</h2><p>Manage this project’s vendor lists, campaigns, coordinators, conversations and next steps in CRM Outreach.</p></div>
        {error && <p className="crm-error" role="alert">{error}</p>}
        {data ? <p>{data.vendors} vendor companies{data.lists !== null ? ` · ${data.lists} lists` : ''} · {workspace === 'test' ? 'Test' : 'Live'} workspace</p> : !error && <p role="status">Loading vendor summary…</p>}
        {data && <Link className="crm-button crm-primary" to={`/crm/outreach?${target}`}>Open project outreach</Link>}
    </section>;
}
